import axios from "axios";
const jsonConfig = require("../../config.json");


const createUserResponse = async (payload) => {
    let allResponse = {}
    try {
        const Response = await  axios.post(
            jsonConfig.apiUrl + "users",payload,
            {
                headers: {
                    "x-functions-key": jsonConfig.key,
                },
            }
        );
        
        allResponse = Response;
        return Promise.resolve(allResponse)
    }
    catch (error) {
        return Promise.reject(error)
    }
}

export default createUserResponse;